import { defineMessages } from 'react-intl';

export default defineMessages({
  approvedScheduledMoveInsTooltip: {
    id: 'App.Portfolio.ApprovedScheduledMoveInsTooltip',
    defaultMessage:
      'Move-ins scheduled within the next 30 days, including past-due scheduled move-ins.',
  },
  monthToDateMoveInsTooltip: {
    id: 'App.Portfolio.MonthToDateMoveInsTooltip',
    defaultMessage: 'Actual move-ins completed this month through today.',
  },
  scheduledMoveOutsTooltip: {
    id: 'App.Portfolio.ScheduledMoveOutsTooltip',
    defaultMessage:
      'Move-outs scheduled within the next 30 days, including past-due scheduled move-outs.',
  },
  monthToDateMoveOutsTooltip: {
    id: 'App.Portfolio.MonthToDateMoveOutsTooltip',
    defaultMessage: 'Actual move-outs completed this month through today.',
  },
});
